module.exports = __webpack_public_path__ + "media/3-1.ead73831.wav";